<template>
  <KeiAvbAnswerTable dict-type="kei" />
</template>

<script>
import KeiAvbAnswerTable from '@/components/dict/kei/KeiAvbAnswerTable'

export default {
  components: { KeiAvbAnswerTable },
}
</script>
